import { CustomFieldDividerState } from './custom-field-dividers.types'

export const state: CustomFieldDividerState = {
  customFieldDividers: {
    Products: [],
    Components: [],
    Variants: []
  },
  dividersByLocation: [],
  dividersLoadingError: null
}
